import { styled } from '@mui/material';

export const IconContainer = styled('span')(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '1.1em',
  height: '1.1em',
  fontSize: '1.5rem',
  flexShrink: 0,
  userSelect: 'none',
}));

export default IconContainer;
